import { InputField, TextareaField } from './form-controls';

/**
 * Step 4 — optional deal context (the `explaination` section). Nothing here is
 * required; the customer can be created with these blank.
 */
export function StepAdditionalInfo() {
  return (
    <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
      <div
        style={{
          display: 'grid',
          gap: 'var(--vn-space-4)',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        }}
      >
        <InputField
          name="explaination.explaination_provider"
          label="Current provider"
          placeholder="Who do they use today?"
        />
        <InputField
          name="explaination.explaination_budget"
          label="Expected budget"
          type="number"
          placeholder="0"
        />
      </div>

      <TextareaField
        name="explaination.explaination_problem"
        label="Problem to solve"
        placeholder="What challenge are they facing?"
        rows={3}
      />
      <TextareaField
        name="explaination.explaination_expected"
        label="Expected outcome"
        placeholder="What does success look like for them?"
        rows={3}
      />
    </div>
  );
}
